import React from "react";
import { HomeCategoryTemplate } from "themes/application/home/components";

function HomeCategory(props) {
    return <HomeCategoryTemplate {...props} />;
}

export default HomeCategory;
